import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import BrandStory from './components/BrandStory';
import AboutAIBlock from './components/AboutAIBlock';
import AboutFAQ from './components/AboutFAQ';
import TrustBar from '../home/components/TrustBar';
import ProcessSection from '../home/components/ProcessSection';
import WhyChooseUs from '../home/components/WhyChooseUs';
import ServiceAreas from '../home/components/ServiceAreas';
import TestimonialsSection from '../home/components/TestimonialsSection';
import FinalCTA from '../home/components/FinalCTA';
import MidPageCTA from '../home/components/MidPageCTA';

const aboutWhyFeatures = [
  { icon: 'ri-medal-line', title: 'Industry Experience', description: 'Founded by creators who have spent years navigating the challenges of finding professional studio space. We understand exactly what working creatives need.', color: 'bg-amber-100 text-amber-600' },
  { icon: 'ri-globe-line', title: 'Multi-City Network', description: 'A growing network of 50+ studio locations across 6 major US markets, all maintained to consistent quality and professional standards.', color: 'bg-emerald-100 text-emerald-600' },
  { icon: 'ri-shield-star-line', title: 'Quality Guaranteed', description: 'Every studio is inspected, equipment-tested, and reset between bookings. You will always walk into a professional, ready-to-use environment.', color: 'bg-rose-100 text-rose-600' },
  { icon: 'ri-heart-line', title: 'Creator-First Mission', description: 'Every product decision, pricing structure, and studio acquisition is made with the working creative professional at the center of the conversation.', color: 'bg-violet-100 text-violet-600' },
  { icon: 'ri-lock-line', title: 'Transparent Pricing', description: 'No membership fees, no hidden charges, no surprise costs. The price you see when you book is the total price you pay — always.', color: 'bg-orange-100 text-orange-600' },
  { icon: 'ri-customer-service-2-line', title: 'Dedicated Support', description: 'A real support team available to assist before, during, and after your booking. We are invested in the success of every creative session.', color: 'bg-teal-100 text-teal-600' },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen font-sans">
      <Header />
      <main>
        {/* 1. Hero */}
        <AboutHero />
        {/* 2. Trust Bar */}
        <TrustBar tagline="Trusted by 10,000+ Creators, Brands & Production Teams" />
        {/* 3. Brand Story */}
        <BrandStory />
        {/* Urgency strip */}
        <MidPageCTA variant="urgency" />
        {/* 4. AI Answer Block */}
        <AboutAIBlock />
        {/* 5. Process */}
        <ProcessSection />
        {/* 6. Why Choose Us */}
        <WhyChooseUs
          features={aboutWhyFeatures}
          title="Why Creators Trust Book My Studio Space"
          subtitle="Built from firsthand experience of what creative professionals actually need from a studio booking platform."
        />
        {/* 7. Service Areas */}
        <ServiceAreas />
        {/* 8. Testimonials */}
        <TestimonialsSection />
        {/* Social CTA */}
        <MidPageCTA variant="social" />
        {/* 9. FAQ */}
        <AboutFAQ />
        {/* 10. Final CTA */}
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
